"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditor = RichTextEditor;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const extensions_1 = require("remirror/extensions");
const react_2 = require("@remirror/react");
const styled_components_2 = require("@remirror/styles/styled-components");
const remirror_1 = require("remirror");
const useIsFirstRender_1 = require("@src/hooks/useIsFirstRender");
const RemirrorEditorWrapper = styled_components_1.default.div `
	.remirror-editor {
		overflow-y: auto !important;
		border: 1px solid ${({ theme }) => theme.color.gray4};
		box-shadow: none !important;
	}
`;
const extensions = () => [
    // @ts-ignore
    new extensions_1.BulletListExtension(),
    new extensions_1.OrderedListExtension(),
    // new ListExtension(),
    // @ts-ignore
    new extensions_1.LinkExtension(),
    new extensions_1.HardBreakExtension(),
    // @ts-ignore
    new extensions_1.BoldExtension(),
    new extensions_1.ItalicExtension(),
    new extensions_1.UnderlineExtension(),
];
function RichTextEditor({ value, editable, onChange }) {
    const isFirstRender = (0, useIsFirstRender_1.useIsFirstRender)();
    const { manager, state, onChange: onRemirrorChange, } = (0, react_2.useRemirror)({
        extensions,
        plugins: [],
        selection: 'end',
        stringHandler: 'html',
        content: value || '',
    });
    const htmlString = (0, remirror_1.prosemirrorNodeToHtml)(state.doc);
    react_1.default.useEffect(() => {
        // we want to skip the first render
        if (!isFirstRender) {
            onChange(htmlString);
        }
    }, [htmlString]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "remirror-theme", children: (0, jsx_runtime_1.jsx)(react_2.ThemeProvider, { children: (0, jsx_runtime_1.jsx)(styled_components_2.AllStyledComponent, { children: (0, jsx_runtime_1.jsxs)(react_2.Remirror, { manager: manager, state: state, onChange: onRemirrorChange, editable: editable, children: [(0, jsx_runtime_1.jsxs)(react_2.Toolbar, { children: [(0, jsx_runtime_1.jsx)(react_2.BasicFormattingButtonGroup, {}), (0, jsx_runtime_1.jsx)(react_2.ToggleBulletListButton, {}), (0, jsx_runtime_1.jsx)(react_2.ToggleOrderedListButton, {})] }), (0, jsx_runtime_1.jsx)(RemirrorEditorWrapper, { children: (0, jsx_runtime_1.jsx)(react_2.EditorComponent, {}) })] }) }) }) }));
}
